import { IonAvatar, IonCard, IonItem, IonLabel, isPlatform } from "@ionic/react";
import { useSelector } from "react-redux";
import UserAvatar from "../../../components/UserAvatar";
import { selectSigners } from "../../../store/documentSignerShow/selectors/selectSigners";

export const DocumentSigners: React.FC = () => {
  const signers = useSelector(selectSigners);

  return (
    <section style={{ maxWidth: "900px" }} className={isPlatform("desktop") ? "ion-padding" : ""}>
      <section className="ion-margin-vertical ion-padding-horizontal">
        <h5 style={{ flex: 1, margin: "auto" }}>{signers.length} firmantes</h5>
      </section>

      {signers.length === 0 && (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          Este documento no tiene firmantes aún.
        </p>
      )}

      {signers.map(({ id, status = {}, stakeholder = {} }, index) => (
        <IonCard key={stakeholder.id}>
          <IonItem lines="none">
            <UserAvatar user={stakeholder}></UserAvatar>
            <IonLabel>
              <h2 style={{ fontWeight: 500 }}>{stakeholder.name}</h2>
              <p>{status?.name}</p>
            </IonLabel>
          </IonItem>
        </IonCard>
      ))}
    </section>
  );
};
